import { DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';

export class LtiAnalytics {
  static taggingEvents: DataAnalyticsTaggingEvents = {
    pageLtiDashboard: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'dashboard',
        subSection1: 'lti',
        subSection2: 'dashboard',
        customPageName: 'wb_goal-dashboard'
      }
    },
    pageLtiGoal_Selection: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'goal-selection',
        subSection1: 'lti',
        subSection2: 'goal-selection',
        customPageName: 'wb_goal-investment-goal'
      },
      process:{
        processName: 'tdw:wbt:diy:investmentGoal',
        processType: 'tdw:wbt:diy:investmentGoal:start'
      },
      application:{
        accountInteractions: 'tdw:wbt:diy:investmentGoal:goal'
      }
    },
    pageLtiInvestor_ProfileSelect: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'investor-profile',
        subSection1: 'lti',
        subSection2: 'investor-profile',
        customPageName: 'wb_goal-investor-profile'
      },
      process:{
        processName: 'tdw:wbt:diy:investmentGoal'
      },
      application:{
        accountInteractions: 'tdw:wbt:diy:investmentGoal:profile'
      }
    },
    pageLtiFund_Goal: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'fund_goal',
        subSection1: 'lti',
        subSection2: 'fund_goal',
        customPageName: 'wb_goal-fund-goal'
      },
      process:{
        processName: 'tdw:wbt:diy:investmentGoal'
      },
      application:{
        accountInteractions: 'tdw:wbt:diy:investmentGoal:fundgoal'
      }
    },
    pageLtiHealth_Check: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'plan_summary',
        subSection1: 'lti',
        subSection2: 'plan_summary',
        customPageName: 'wb_goal-plan-summary'
      },
      process:{
        processName: 'tdw:wbt:diy:investmentGoal',
        processType: 'tdw:wbt:diy:investmentGoal:complete'
      },
      application:{
        accountInteractions: 'tdw:wbt:diy:investmentGoal:summary'
      }
    },
    modalLtiPerformance: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'performance details',
        subSection1: 'goal-selection',
        subSection2: 'portfolio',
        customPageName: 'wb_goal-performance-details'
      }
    }
  }
}
